import { render, staticRenderFns } from "./OurThoughts.vue?vue&type=template&id=9ab03670&scoped=true"
import script from "./OurThoughts.vue?vue&type=script&lang=js"
export * from "./OurThoughts.vue?vue&type=script&lang=js"
import style0 from "./OurThoughts.vue?vue&type=style&index=0&id=9ab03670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab03670",
  null
  
)

export default component.exports